import React from 'react';
import { HashRouter, Redirect, Route, Switch } from 'react-router-dom';

import './App.css';
import Layout from './components/Layout';
import { useUserState } from './context/UserContext';
import Error from './pages/error';
import Login from './pages/login';
import NewLogin from './pages/login/NewLogin';
import ResetPassword from './pages/resetPassword/ResetPassword';
import VerifyEmail from './pages/verifyEmail/VerifyEmail';

export default function App() {
  var { isAuthenticated } = useUserState();
  return (
    <HashRouter>
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/app/redirectPage" />} />
        <Route exact path="/app" render={() => <Redirect to="/app/redirectPage" />} />
        <PrivateRoute path="/app" component={Layout} />
        <PublicRoute path="/login" component={NewLogin} />
        <PublicRoute path="/oldlogin" component={Login} />
        <PublicRoute path="/reset-password/uid/:UID/token/:token" component={ResetPassword} />
        <PublicRoute path="/verify-email/:emailToken" component={VerifyEmail} />
        <Route component={Error} />
      </Switch>
    </HashRouter>
  );
  // #######################################################################
  function PrivateRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (React.createElement(component, props)) : 
            (<Redirect to={{ pathname: '/login' , state: {from: props.location}}} />)
        }
      />
    );
  }
  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? 
            (props.location && props.location.state && props.location.state.from ? <Redirect to={{...props.location.state.from}} /> : <Redirect to={{pathname: '/'}} />) : 
            (React.createElement(component, props))
        }
      />
    );
  }
}
